module.exports = {
  PUBLIC: 1,
  PRIVATE: 2,
  HIDDEN: 3
}